import produce from 'immer';
import { SHOW, HIDE } from './actions';

const initialState = {
  isLoading: false,
};

export type LoaderStateType = typeof initialState;

export default produce((draft: LoaderStateType, action) => {
  switch (action.type) {
    case SHOW:
      draft.isLoading = true;
      break;
    case HIDE:
      draft.isLoading = false;
      break;
    default:
    // nothing
  }
}, initialState);
